// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#uploader[data-v-4b7413c1]{-webkit-transition:all .3s ease;transition:all .3s ease;background-color:rgba(0,0,0,.2);border:2px dashed #5b5b5b!important}.drag-over[data-v-4b7413c1]{border:2px dashed #fff!important;background-color:rgba(33,150,243,.33)!important}", ""]);
// Exports
module.exports = exports;
